import _defineProperty from "@babel/runtime/helpers/defineProperty";
// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled
import { css } from '@emotion/react';
import { akEditorFullPageNarrowBreakout } from '@atlaskit/editor-shared-styles';
export var resizerItemClassName = 'resizer-item';
export var resizerHoverZoneClassName = 'resizer-hover-zone';
export var resizerExtendedZone = 'resizer-is-extended';
export var resizerHandleClassName = 'resizer-handle';
export var resizerHandleTrackClassName = "".concat(resizerHandleClassName, "-track");
export var resizerHandleThumbClassName = "".concat(resizerHandleClassName, "-thumb");
export var resizerDangerClassName = "".concat(resizerHandleClassName, "-danger");
export var resizerHandleThumbWidth = 3;
export var handleWrapperClass = 'resizer-handle-wrapper';

// eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766, Seems perfectly safe to autofix, but comments would be lost…
export var resizerStyles = css(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, ".".concat(resizerItemClassName), _defineProperty({
  willChange: 'width',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&:hover, &.display-handle': _defineProperty({}, "& > .".concat(handleWrapperClass, " > .").concat(resizerHandleClassName), {
    visibility: 'visible',
    opacity: 1
  }),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.is-resizing': _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    background: "var(--ds-border-focused, #4688EC)"
  })
}, "&.".concat(resizerDangerClassName), _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
  transition: 'none',
  background: "var(--ds-icon-danger, #C9372C)"
}))), ".".concat(resizerHandleClassName), {
  display: 'flex',
  visibility: 'hidden',
  opacity: 0,
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  width: 7,
  transition: 'visibility 0.2s, opacity 0.2s',
  // NOTE: The below style is targeted at the div element added by the tooltip. We don't have any means of injecting styles
  // into the tooltip
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  "& div[role='presentation']": {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: "var(--ds-space-negative-200, -16px)",
    whiteSpace: 'normal'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.left': {
    alignItems: 'flex-start'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.right': {
    alignItems: 'flex-end'
  },
  // Handle Sizing
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.small': _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    height: 43
  }),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.medium': _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    height: 64
  }),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.large': _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    height: 96
  }),
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.clamped': _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    height: 'clamp(43px, calc(100% - 32px), 96px)'
  }),
  // Handle Alignment
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.sticky': _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    position: 'sticky',
    top: "var(--ds-space-150, 12px)",
    bottom: "var(--ds-space-150, 12px)"
  }),
  '&:hover': _defineProperty(_defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
    background: "var(--ds-border-focused, #4688EC)"
  }), "& .".concat(resizerHandleTrackClassName), {
    visibility: 'visible',
    opacity: 0.5
  })
}), ".".concat(resizerHandleThumbClassName), {
  content: "' '",
  display: 'flex',
  width: 3,
  margin: "0 ".concat("var(--ds-space-025, 2px)"),
  height: 64,
  transition: 'background-color 0.2s',
  borderRadius: "var(--ds-radius-medium, 6px)",
  border: 0,
  padding: 0,
  zIndex: 2,
  outline: 'none',
  minHeight: 24,
  background: "var(--ds-border, #0B120E24)",
  '&:hover': {
    cursor: 'col-resize'
  },
  '&:focus': {
    background: "var(--ds-border-selected, #1868DB)",
    '&::after': {
      content: "''",
      position: 'absolute',
      top: "var(--ds-space-negative-050, -4px)",
      right: "var(--ds-space-negative-050, -4px)",
      bottom: "var(--ds-space-negative-050, -4px)",
      left: "var(--ds-space-negative-050, -4px)",
      border: "2px solid ".concat("var(--ds-border-focused, #4688EC)"),
      borderRadius: 'inherit',
      zIndex: -1
    }
  }
}), ".".concat(resizerHandleTrackClassName), {
  visibility: 'hidden',
  position: 'absolute',
  width: 7,
  height: 'calc(100% - 40px)',
  borderRadius: "var(--ds-radius-small, 4px)",
  opacity: 0,
  transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.none': {
    background: 'none'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.shadow': {
    background: "var(--ds-background-selected, #E9F2FE)"
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '&.full-height': {
    background: "var(--ds-background-selected, #E9F2FE)",
    height: '100%',
    minHeight: 36
  }
}), '.ak-editor-selected-node', _defineProperty({}, "& .".concat(resizerHandleThumbClassName), {
  background: "var(--ds-border-focused, #4688EC)"
})), ".ak-editor-no-interaction .ak-editor-selected-node .".concat(resizerHandleClassName, ":not(:hover) .").concat(resizerHandleThumbClassName), {
  background: "var(--ds-border, #0B120E24)"
}), "&.resizer-hover-zone-cls-fix .".concat(resizerHoverZoneClassName), {
  display: 'flow-root'
}), ".".concat(resizerHoverZoneClassName), _defineProperty({
  position: 'relative',
  display: 'inline-block',
  width: '100%'
}, "&.".concat(resizerExtendedZone), {
  padding: "0 ".concat("var(--ds-space-150, 12px)"),
  left: "var(--ds-space-negative-150, -12px)"
})), "table .".concat(resizerHoverZoneClassName, ", table .").concat(resizerHoverZoneClassName, ".").concat(resizerExtendedZone), {
  padding: 'unset',
  left: 'unset'
}));

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticResizerStylesForTooltip = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-rail-wrapper': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    cursor: 'col-resize',
    borderRadius: "var(--ds-radius-small, 4px)",
    zIndex: 2,
    // Tootip element
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '[role="presentation"]': {
      height: '100%',
      width: '100%'
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-rail-inside-tooltip': {
      height: '100%'
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticStylesLayoutFirstNodeResizeHandleFix = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.fabric-editor-breakout-mark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="layoutSection"].first-node-in-document)': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 8px)'
      }
    }
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticResizerStyles = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.fabric-editor-breakout-mark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="codeBlock"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--left': {
        left: '-12px'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--right': {
        right: '-12px'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 12px)'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--left': {
        left: '-32px'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--right': {
        right: '-32px'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="expand"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 4px)'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="layoutSection"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 8px)'
      }
    },
    // the first node in the document always has margin-top = 0
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.first-node-in-document)': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: '100%'
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container': {
    position: 'relative',
    alignSelf: 'end',
    gridRow: 1,
    gridColumn: 1,
    height: '100%',
    width: 7
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container--left': {
    justifySelf: 'start'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container--right': {
    justifySelf: 'end'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-rail': {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    cursor: 'col-resize',
    borderRadius: "var(--ds-radius-small, 4px)",
    transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
    zIndex: 2,
    opacity: 0,
    '&:hover': {
      background: "var(--ds-background-selected, #E9F2FE)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.pm-breakout-resize-handle-thumb': {
        background: "var(--ds-border-focused, #4688EC)"
      }
    }
  },
  // same as 'hover' styles above
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container--active': {
    background: "var(--ds-background-selected, #E9F2FE)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
      background: "var(--ds-border-focused, #4688EC)"
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-hit-box': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: -20,
    right: -20,
    zIndex: 0
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-thumb': {
    minWidth: resizerHandleThumbWidth,
    // copied from resizeStyles.clamped
    height: 'clamp(27px, calc(100% - 32px), 96px)',
    background: "var(--ds-border, #0B120E24)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    // sticky styles
    position: 'sticky',
    top: "var(--ds-space-150, 12px)",
    bottom: "var(--ds-space-150, 12px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticResizerStylesNew = css({
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.fabric-editor-breakout-mark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="codeBlock"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--left': {
        left: '-5px'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--right': {
        right: '-5px'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 12px)'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--left': {
        left: '-25px'
      },
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container--right': {
        right: '-25px'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="expand"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 4px)'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="layoutSection"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: 'calc(100% - 8px)'
      }
    },
    // the first node in the document always has margin-top = 0
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has(.first-node-in-document)': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        height: '100%'
      }
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container': {
    position: 'relative',
    alignSelf: 'end',
    gridRow: 1,
    gridColumn: 1,
    height: '100%',
    width: 7
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container--left': {
    justifySelf: 'start'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container--right': {
    justifySelf: 'end'
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-rail': {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
    cursor: 'col-resize',
    borderRadius: "var(--ds-radius-small, 4px)",
    transition: 'background-color 0.2s, visibility 0.2s, opacity 0.2s',
    zIndex: 2,
    opacity: 0,
    '&:hover': {
      background: "var(--ds-background-selected, #E9F2FE)",
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '.pm-breakout-resize-handle-thumb': {
        background: "var(--ds-border-focused, #4688EC)"
      }
    }
  },
  // same as 'hover' styles above
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-container--active': {
    background: "var(--ds-background-selected, #E9F2FE)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '.pm-breakout-resize-handle-thumb': {
      background: "var(--ds-border-focused, #4688EC)"
    }
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-hit-box': {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: -20,
    right: -20,
    zIndex: 0
  },
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.pm-breakout-resize-handle-thumb': {
    minWidth: resizerHandleThumbWidth,
    // copied from resizeStyles.clamped
    height: 'clamp(27px, calc(100% - 32px), 96px)',
    background: "var(--ds-border, #0B120E24)",
    borderRadius: "var(--ds-radius-medium, 6px)",
    // sticky styles
    position: 'sticky',
    top: "var(--ds-space-150, 12px)",
    bottom: "var(--ds-space-150, 12px)"
  }
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles
export var pragmaticResizerStylesWithReducedEditorGutter = css(_defineProperty({}, "@container editor-area (max-width: ".concat(akEditorFullPageNarrowBreakout, "px)"), {
  // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
  '.fabric-editor-breakout-mark': {
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="expand"]), &:has([data-prosemirror-node-name="layoutSection"])': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '> .pm-breakout-resize-handle-container': {
        opacity: 0,
        visibility: 'hidden'
      }
    },
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors
    '&:has([data-prosemirror-node-name="layoutSection"])': _defineProperty({}, ".".concat(resizerItemClassName), {
      willChange: 'width',
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
      '&:hover, &.display-handle': _defineProperty({}, "& > .".concat(handleWrapperClass, " > .").concat(resizerHandleClassName), {
        visibility: 'hidden',
        opacity: 0
      })
    })
  }
}));